import _ from 'underscore';
import config from '@bingads-webui-component-legacy/config/index';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

let headlinePositionMenu = [
  { text: i18n.get('Ad_Headline_PinToPosition_0'), value: 'None' },
  { text: i18n.get('Ad_Headline_PinToPosition_1'), value: 'Headline1' },
  { text: i18n.get('Ad_Headline_PinToPosition_2'), value: 'Headline2' },
  { text: i18n.get('Ad_Headline_PinToPosition_3'), value: 'Headline3' },
];

let descriptionPositionMenu = [
  { text: i18n.get('Ad_Description_PinToPosition_0'), value: 'None' },
  { text: i18n.get('Ad_Description_PinToPosition_1'), value: 'Description1' },
  { text: i18n.get('Ad_Description_PinToPosition_2'), value: 'Description2' },
];

export default {
  extendHeadlines(viewModel) {
    const headlineFields = config.get('headlineFields');

    _.each(headlineFields, (field) => {
      const property = viewModel[field];

      property.selectPosition = (data) => {
        viewModel[`${field}Position`](data.value);
      };
      property.positionMenu = headlinePositionMenu;
    });
  },

  extendDescriptions(viewModel) {
    const descriptionFields = config.get('descriptionFields');

    _.each(descriptionFields, (field) => {
      const property = viewModel[field];

      property.selectPosition = (data) => {
        viewModel[`${field}Position`](data.value);
      };
      property.positionMenu = descriptionPositionMenu;
    });
  },
};
